import { useSelector } from 'react-redux';
import { getBaseEventMetadata, isLoadingBaseEvent } from '../selectors';

export const useBaseEventMetadata = () => {
  const metadata = useSelector(getBaseEventMetadata);
  const isLoading = useSelector(isLoadingBaseEvent);

  return [metadata, isLoading];
};
